angular.module('MyHippoProducer.Controllers').directive('optionalBusinessCoverageSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-business-coverage/optional-business-coverage.html',
    };
});
